import { getBaseURL } from 'service/env'

// Documento já migrado para o S3 vem com URL absoluta e assinada; só o legado
// (CarrierWave, ainda em disco) vem relativo à API.
const buildDocumentUrl = (url) =>
  url?.startsWith('http') ? url : `${getBaseURL('dponet')}${url}`

export default buildDocumentUrl
